import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import BookTable from './table/js/bookTable';
import BookCreate from './create/js/bookCreate';

export default function BooksManagement() {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  return (
    <div className="eduss-student-management">
      <div className="eduss-student-management-content">
        <BookTable
          reloadKey={reloadKey}
          onCreate={() => setShowCreateModal(true)}
        />
      </div>

      {showCreateModal && createPortal(
        <div className="eduss-global-modal-overlay" onClick={() => setShowCreateModal(false)}>
          <div className="eduss-global-modal large eduss-admin-form-modal" onClick={e => e.stopPropagation()}>
            <div className="eduss-global-modal-header">
              <h3>Create New Book</h3>
              <button onClick={() => setShowCreateModal(false)}>&times;</button>
            </div>
            <div className="eduss-global-modal-content">
              <BookCreate onClose={() => setShowCreateModal(false)} onSubmit={() => { setReloadKey(k => k + 1); setShowCreateModal(false); }} />
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
}
